import {Component, HostBinding} from "@angular/core";

@Component({
    selector: "fui-page-main",
    styleUrls: ["./page-main.component.scss"],
    templateUrl: "./page-main.component.html",
    standalone: false
})
export class FUIPageMainComponent {
}
